package dev.akshaychordiya.pages.articles

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initBuildingModernAppsUsingTheAndroidArchitectureGuidelinesPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("articles/BuildingModernAppsUsingTheAndroidArchitectureGuidelines.md", FrontMatterElement.Builder { addScalar("title", "Building Modern apps using the Android Architecture Guidelines"); addScalar("date", "2018-02-26"); addScalar("description", "In this article you’ll learn what are Android Architecture Guideline and how to use them to build modern Android apps with the help of architecture components."); addScalar("originalUrl", "https://proandroiddev.com/building-modern-apps-using-the-android-architecture-guidelines-3238fff96f14"); addScalar("originalName", "Medium"); addScalar("image", "/images/articles/building-modern-apps-using-the-android-architecture-guidelines/1f1HRu4YeZDn3PAS81QjuNg.webp"); }))
}

@Page("/articles/building-modern-apps-using-the-android-architecture-guidelines")
@Layout(".components.layouts.ArticleLayout")
@Composable
fun BuildingModernAppsUsingTheAndroidArchitectureGuidelinesPage() {
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/building-modern-apps-using-the-android-architecture-guidelines/1f1HRu4YeZDn3PAS81QjuNg.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Code (")
            com.varabyte.kobweb.silk.components.navigation.Link("https://unsplash.com/photos/dC6Pb2JdAqs") {
                org.jetbrains.compose.web.dom.Text("Credits")
            }
            org.jetbrains.compose.web.dom.Text(")")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("content") }) {
        org.jetbrains.compose.web.dom.Text("Content")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/introduction-to-android-architecture-components-22b8c84f0b9d") {
                org.jetbrains.compose.web.dom.Text("Introduction to Android Architecture Components")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/exploring-viewmodel-architecture-component-5d60828172f9") {
                org.jetbrains.compose.web.dom.Text("Exploring ViewModel Architecture component")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/exploring-livedata-architecture-component-f9375d3644ee") {
                org.jetbrains.compose.web.dom.Text("Exploring LiveData Architecture component")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/exploring-room-architecture-component-6db807094241") {
                org.jetbrains.compose.web.dom.Text("Exploring Room Architecture component")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/exploring-room-the-extras-cf3f0259ceed") {
                org.jetbrains.compose.web.dom.Text("Exploring Room Architecture component — The Extras")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/building-modern-apps-using-the-android-architecture-guidelines-3238fff96f14") {
                org.jetbrains.compose.web.dom.Text("Building Modern apps using the Android Architecture Guidelines")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("preface") }) {
        org.jetbrains.compose.web.dom.Text("Preface")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In this article you’ll learn what are ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/libraries/architecture/guide.html") {
            org.jetbrains.compose.web.dom.Text("Android Architecture Guideline")
        }
        org.jetbrains.compose.web.dom.Text(" and how to use them to build modern Android apps with the help of architecture components.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you prefer ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("videos")
        }
        org.jetbrains.compose.web.dom.Text(", please head over to:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://caster.io/courses/android-architecture-components-deep-dive") {
            org.jetbrains.compose.web.dom.Text("Android Architecture Components - A Deep Dive")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("OR")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you directly ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("want the code")
        }
        org.jetbrains.compose.web.dom.Text(", please head on to:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/AkshayChordiya/android-arch-news-sample") {
            org.jetbrains.compose.web.dom.Text("AkshayChordiya/android-arch-news-sample")
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("In case you are ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("not aware")
            }
            org.jetbrains.compose.web.dom.Text(" about architecture components then check out my previous series of articles starting with ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/introduction-to-android-architecture-components-22b8c84f0b9d") {
                org.jetbrains.compose.web.dom.Text("Introduction to Android Architecture Components")
            }
            org.jetbrains.compose.web.dom.Text(".")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("architecture-guidelines") }) {
        org.jetbrains.compose.web.dom.Text("Architecture Guidelines")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Android Architecture Guidelines are a set of best practices and recommended architecture pattern by Android Team; on how to build testable and production-quality apps.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/building-modern-apps-using-the-android-architecture-guidelines/1-yY0l4XD3kLcZz0rO1sfRA.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Final Architecture")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This is the architecture diagram recommended by Android Team in Architecture guidelines.")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("It suggests to keep our *")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Activity and Fragments lean by only maintaining UI")
            }
            org.jetbrains.compose.web.dom.Text(" *related code like click listeners, etc.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("And the ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("ViewModel provides the data required by the UI")
            }
            org.jetbrains.compose.web.dom.Text(" controllers like Activity and Fragments, this helps in surviving configuration change.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("While ViewModel gets the data from ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Repository which acts as single source of truth for data")
            }
            org.jetbrains.compose.web.dom.Text(", that means whenever your app requires data, it always comes from Repository.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Now Repository decides if the data is to be fetched from local database using Room or from web service using Retrofit.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In a nutshell,")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/af7d57c248574b43f2916736fc3e7507/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It’s recommended to use Dependency Injection (cough….")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/google/dagger") {
            org.jetbrains.compose.web.dom.Text("Dagger")
        }
        org.jetbrains.compose.web.dom.Text("….cough) or Service Locator pattern to manage dependencies between the components.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("exposing-data-and-state") }) {
        org.jetbrains.compose.web.dom.Text("Exposing data and state")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When working with ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/libraries/architecture/livedata.html") {
            org.jetbrains.compose.web.dom.Text("LiveData")
        }
        org.jetbrains.compose.web.dom.Text(", by default you just get data but not the state like loading, error and success as mentioned in ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/libraries/architecture/guide.html#addendum") {
            org.jetbrains.compose.web.dom.Text("Addendum section of Guide")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Resource class holds the ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("state")
        }
        org.jetbrains.compose.web.dom.Text(" viz. SUCCESS, ERROR or LOADING , ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("data")
        }
        org.jetbrains.compose.web.dom.Text(" and ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("error message")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/7abc07d7cd0be535720efae73c4e9102/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("With this our ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/libraries/architecture/livedata.html") {
            org.jetbrains.compose.web.dom.Text("LiveData")
        }
        org.jetbrains.compose.web.dom.Text(" will be able to indicate data and state to our Activity or Fragments in the following example:")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("// Activity or Fragment\nviewModel.getFeeds().observe(this,Observer<**Resource**<List<Feed>?>?> {\n    it?.let { resource ->\n       when (resource.status) {\n            Status.SUCCESS -> { \n                // Update the UI\n            }\n            Status.ERROR -> {\n                // Show error toast or error indicator\n            }\n            Status.LOADING -> {\n                // Show progress bar\n            }\n       }\n   }\n})\n") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("And our ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/libraries/architecture/viewmodel.html") {
            org.jetbrains.compose.web.dom.Text("ViewModel")
        }
        org.jetbrains.compose.web.dom.Text(" will most likely look like this:")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("class FeedViewModel : ViewModel() {\n") } }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("    */**\n     * Complete list of feeds\n     */\n    *private var feeds: LiveData<Resource<List<Feed>?>>\n") } }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("    init {\n        feeds = /* Get the feeds using Repository */     **\n    **}\n") } }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("    */**\n     * Get list of feeds\n     */\n    *fun getFeeds() = feeds\n") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This small wrapping of ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/topic/libraries/architecture/livedata.html") {
            org.jetbrains.compose.web.dom.Text("LiveData")
        }
        org.jetbrains.compose.web.dom.Text(" is extremely useful to update the UI based upon the ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("state")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("PS: You’ll soon see how well it works to have sync between DB and Web")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("persisting-data") }) {
        org.jetbrains.compose.web.dom.Text("Persisting data")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Most modern Android apps maintain a synchronization between local database and the web service, this is super useful for users which helps in using the app even if the device is offline. This is something which users have started to now-a-days expect in apps.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The same is stated in the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/distribute/best-practices/develop/build-for-the-next-billion.html") {
            org.jetbrains.compose.web.dom.Text("Building for Billion")
        }
        org.jetbrains.compose.web.dom.Text(" guide and the guidelines shows how the data should flow between web and local database in the diagram below:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/building-modern-apps-using-the-android-architecture-guidelines/1_H-8ATlEHKtVFZtVgnMeow.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Data flow between Local Database and Web service")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It states to first fetch the data from local database; if the data doesn’t exist then make the required network call based upon the “should fetch” condition and then save the fetched data into the local database on response.")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Remember, your UI should always reflect based on the data in the database.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This is a very common use-case hence the Android Team already created a helper class called NetworkBoundResource.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("demystifying-networkboundresource") }) {
        org.jetbrains.compose.web.dom.Text("Demystifying NetworkBoundResource")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("NetworkBoundResource is a plain class which does the job of data flow between local database and your web-service using the power of ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developer.android.com/reference/android/arch/lifecycle/MediatorLiveData.html") {
            org.jetbrains.compose.web.dom.Text("MediatorLiveData")
        }
        org.jetbrains.compose.web.dom.Text(" and the Resource class to send state and data upstream to the Activity or Fragment.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This class is extremely well made. It works exactly as shown in the data flow diagram above (in case the diagram was too much, see the flow below)")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Initially it sends event for loading")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Fetches the data from local database (Note: It can be empty too)")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Checks the condition in “shouldFetch”")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("If false, then sends the data upstream from local database")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("If true, it performs the required network call and fetch the data")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("On response, the data is then saved into local database and this data and event is sent upstream")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Now, I have cut down couple of things for simplicity and only focused on important parts in the flow explanation.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/89a4610020b8db6a5cd42f2a4a630ce8/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In case you are wondering about ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/googlesamples/android-architecture-components/blob/master/GithubBrowserSample/app/src/main/java/com/android/example/github/AppExecutors.kt") {
            org.jetbrains.compose.web.dom.Text("AppExecutors class, grab it from here")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("usage") }) {
        org.jetbrains.compose.web.dom.Text("Usage")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Let’s look at a sample usage of this class to exactly understand how this class works.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("NetworkBoundResource is an abstract class, hence when you create object of it you’ll need to override the following methods")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("loadFromDb() — Contains the logic to get data from database (Like Room)")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("shouldFetch() — Returns boolean indicating if to fetch data from web or not, true means fetch the data from web.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("createCall() — Contains the logic to get data from web-service (cough..Retrofit..cough)")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("saveCallResult() — Here we save the data fetched from web-service")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/cb65989f2c1202a273d0717deecd3f7f/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("testing") }) {
        org.jetbrains.compose.web.dom.Text("Testing")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Architecture Guidelines helps keeps all the components isolated which is excellent for testing")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/media/768542446aa2f925d607c1b06c4f2d00/href") {
            org.jetbrains.compose.web.dom.Text("View the code on GitHub Gist")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Spoiler Alert")
        }
        org.jetbrains.compose.web.dom.Text(": I’ll be posting a couple of articles on testing the Architecture Components pretty soon.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Okay, enough of theory. So, I have build a very simple news app using Architecture Guidelines to showcase building apps with them. Check it out to see some concrete code:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/AkshayChordiya/android-arch-news-sample/") {
            org.jetbrains.compose.web.dom.Text("AkshayChordiya/android-arch-news-sample")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("conclusion") }) {
        org.jetbrains.compose.web.dom.Text("Conclusion")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Android Architecture Guidelines are ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("amazing")
        }
        org.jetbrains.compose.web.dom.Text(" and personally I am glad that finally the Android Team has given us their opinion on how to build modern and ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("production-quality")
        }
        org.jetbrains.compose.web.dom.Text(" Android apps.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Feel free to ping me in case you want to hear more on this topic and you can ping on ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://twitter.com/Akshay_Chordiya") {
            org.jetbrains.compose.web.dom.Text("Twitter")
        }
        org.jetbrains.compose.web.dom.Text(" for questions.")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("No architecture is perfect for every use-case and Architecture Guidelines are just recommendations.")
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Hence feel free to use whatever suites your use-case.")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://proandroiddev.com/building-modern-apps-using-the-android-architecture-guidelines-3238fff96f14") {
            org.jetbrains.compose.web.dom.Text("Building Modern apps using the Android Architecture Guidelines")
        }
        org.jetbrains.compose.web.dom.Text(" was originally published in ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://proandroiddev.com") {
            org.jetbrains.compose.web.dom.Text("ProAndroidDev")
        }
        org.jetbrains.compose.web.dom.Text(" on Medium, where people are continuing the conversation by highlighting and responding to this story.")
    }
}
